<div matDialogTitle>{{ data.title }}</div>
<div matDialogContent>
  @for (message of data.message; track $index) {
    <p style="padding: 1px">{{ message }}</p>
  }
</div>

@if (data.error) {
  <p>{{ data.error }}</p>
}

@if (data.close) {
  <div matDialogActions>
    <button mat-flat-button matDialogClose="">Stäng
    </button>
  </div>
}